import { JsonRestApiRequestConfig, makeJsonRestApiRequest} from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IScimConfiguration } from '../../services/ScimConfigurationsService';

export function deleteScimConfigurationRequestConfig(scimConfig: IScimConfiguration): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'DELETE',
    endpoint: `scimConfigurations/${scimConfig.id}`,
    serverWideRequest: false
  };
}


export function callDeleteScimConfigurationRequest(scimConfig: IScimConfiguration): Promise<IResult> {
  return makeJsonRestApiRequest<void,IResult>({
    config: deleteScimConfigurationRequestConfig(scimConfig),
    request: null
  });
}